import React, { useState } from 'react';
import { db } from '../../../firebase';
import { ref, push } from 'firebase/database';
import { FiUser,FiCheckCircle, FiBook, FiAward, FiClock, FiDollarSign, FiLayers } from 'react-icons/fi';

const ALevel = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await push(ref(db, 'enquiries/alevel'), {
        ...form,
        course: 'A Level',
        createdAt: new Date().toISOString()
      });
      setSubmitted(true);
      setForm({ name: '', email: '', phone: '', message: '' });
      setTimeout(() => setSubmitted(false), 3000);
    } catch (err) {
      alert('Error saving data!');
    } finally {
      setIsLoading(false);
    }
  };

  // Course details
  const courseDetails = {
    duration: '1 Year',
    eligibility: 'O Level or 10+2 with Computer Knowledge',
    examBody: 'NIELIT (DOEACC)',
    recognition: 'Government of India recognized',
    fee: {
      total: '₹25,000',
      semester1: '₹12,500',
      semester2: '₹12,500',
      installment: 'Available (2 installments)'
    }
  };

  // Semester-wise subjects
  const semesters = [
    {
      name: 'Semester 1',
      subjects: [
        'IT Tools and Business Systems',
        'Internet Technology and Web Design',
        'Programming and Problem Solving Through C Language',
        'Computer Organization and Operating System'
      ]
    },
    {
      name: 'Semester 2',
      subjects: [
        'Data Structure Through C++',
        'Introduction to DBMS',
        'Software Engineering',
        'Practical - Lab Work and Project'
      ]
    }
  ];

  const features = [
    { icon: <FiAward className="feature-icon" />, text: `Government recognized (${courseDetails.examBody})` },
    { icon: <FiLayers className="feature-icon" />, text: 'Advanced programming and system development' },
    { icon: <FiUser className="feature-icon" />, text: `Eligibility: ${courseDetails.eligibility}` },
    { icon: <FiClock className="feature-icon" />, text: `Duration: ${courseDetails.duration}` },
    { icon: <FiDollarSign className="feature-icon" />, text: `Total Fee: ${courseDetails.fee.total}` },
    { icon: <FiBook className="feature-icon" />, text: 'Prepares for software development careers' }
  ];

  return (
    <div className="alevel-container">
      <div className="alevel-card">
        <div className="alevel-header">
          <span className="alevel-badge">Advanced Course</span>
          <h1 className="alevel-title">A Level Course</h1>
          <p className="alevel-subtitle">Advanced Diploma in Computer Applications</p>
          
          <div className="alevel-highlights">
            <span className="highlight-item">
              <FiClock className="highlight-icon" /> {courseDetails.duration}
            </span>
            <span className="highlight-item">
              <FiAward className="highlight-icon" /> {courseDetails.examBody}
            </span>
            <span className="highlight-item">
              <FiDollarSign className="highlight-icon" /> {courseDetails.fee.total}
            </span>
          </div>
        </div>

        <div className="alevel-image-container">
          <img 
            src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=600&q=80" 
            alt="A Level Course" 
            className="alevel-image" 
          />
        </div>

        <div className="alevel-content">
          <div className="alevel-section">
            <h3 className="section-title">Course Overview</h3>
            <p className="section-text">
              The A Level course is an advanced IT professional program recognized by the Government of India. 
              It provides in-depth knowledge of programming, database management, and software engineering, 
              preparing students for careers in software development and system administration.
            </p>
          </div>

          <div className="alevel-section">
            <h3 className="section-title">Semester-wise Subjects</h3>
            <div className="semesters-container">
              {semesters.map((semester, index) => (
                <div key={index} className="semester-card">
                  <h4 className="semester-title">{semester.name}</h4>
                  <ul className="subject-list">
                    {semester.subjects.map((subject, i) => (
                      <li key={i} className="subject-item">
                        <FiBook className="subject-icon" /> {subject}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="alevel-section">
            <h3 className="section-title">Fee Structure</h3>
            <div className="fee-structure">
              <div className="fee-item">
                <span className="fee-label">Total Course Fee:</span>
                <span className="fee-value">{courseDetails.fee.total}</span>
              </div>
              <div className="fee-item">
                <span className="fee-label">Semester 1:</span>
                <span className="fee-value">{courseDetails.fee.semester1}</span>
              </div>
              <div className="fee-item">
                <span className="fee-label">Semester 2:</span>
                <span className="fee-value">{courseDetails.fee.semester2}</span>
              </div>
              <div className="fee-item">
                <span className="fee-label">Payment Options:</span>
                <span className="fee-value">{courseDetails.fee.installment}</span>
              </div>
            </div>
          </div>

          <div className="alevel-features">
            <h3 className="section-title">Key Features</h3>
            <div className="features-grid">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  {feature.icon}
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="alevel-form">
          <h3 className="form-title">Enquire Now</h3>
          <div className="form-group">
            <input 
              type="text" 
              name="name" 
              placeholder="Your Full Name" 
              required 
              value={form.name} 
              onChange={handleChange} 
              className="form-input" 
            />
          </div>
          
          <div className="form-group">
            <input 
              type="email" 
              name="email" 
              placeholder="Your Email Address" 
              required 
              value={form.email} 
              onChange={handleChange} 
              className="form-input" 
            />
          </div>
          
          <div className="form-group">
            <input 
              type="tel" 
              name="phone" 
              placeholder="Your Phone Number" 
              required 
              value={form.phone} 
              onChange={handleChange} 
              className="form-input" 
            />
          </div>
          
          <div className="form-group">
            <textarea 
              name="message" 
              placeholder="Your Questions or Message" 
              required 
              value={form.message} 
              onChange={handleChange} 
              className="form-textarea" 
            />
          </div>
          
          <button 
            type="submit" 
            className={`submit-button ${submitted ? 'success' : ''} ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              'Processing...'
            ) : submitted ? (
              <>
                <FiCheckCircle className="button-icon" />
                Enquiry Submitted!
              </>
            ) : (
              'Get Course Details'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ALevel;

// CSS Styles
const styles = `
  .alevel-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  }

  .alevel-card {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    padding: 2.5rem;
    max-width: 800px;
    width: 100%;
    position: relative;
    overflow: hidden;
  }

  .alevel-header {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .alevel-badge {
    display: inline-block;
    background-color: #4cc9f0;
    color: white;
    padding: 0.3rem 0.8rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .alevel-title {
    color: #2b2d42;
    font-weight: 700;
    margin-bottom: 0.5rem;
    font-size: 2rem;
  }

  .alevel-subtitle {
    color: #4a4e69;
    margin-bottom: 1rem;
    font-size: 1.1rem;
    line-height: 1.5;
  }

  .alevel-highlights {
    display: flex;
    justify-content: center;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
  }

  .highlight-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    font-weight: 500;
    color: #4a4e69;
    background: #f8f9fa;
    padding: 0.5rem 1rem;
    border-radius: 8px;
  }

  .highlight-icon {
    color: #4361ee;
  }

  .alevel-image-container {
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 1.5rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .alevel-image {
    width: 100%;
    height: 220px;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
  }

  .alevel-image:hover {
    transform: scale(1.02);
  }

  .alevel-content {
    margin-bottom: 2rem;
  }

  .alevel-section {
    margin-bottom: 1.5rem;
  }

  .section-title {
    color: #2b2d42;
    font-size: 1.3rem;
    margin-bottom: 0.8rem;
    position: relative;
    padding-bottom: 0.5rem;
  }

  .section-title:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 3px;
    background: #4361ee;
    border-radius: 3px;
  }

  .section-text {
    color: #4a4e69;
    line-height: 1.6;
    margin-bottom: 1rem;
  }

  .semesters-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .semester-card {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 1rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  }

  .semester-title {
    color: #2b2d42;
    font-size: 1.1rem;
    margin-bottom: 0.8rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .subject-list {
    list-style: none;
    padding-left: 0;
    margin: 0;
  }

  .subject-item {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 0.6rem;
    color: #4a4e69;
    font-size: 0.95rem;
  }

  .subject-icon {
    color: #4361ee;
    margin-top: 0.2rem;
    flex-shrink: 0;
  }

  .fee-structure {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 1rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  }

  .fee-item {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    border-bottom: 1px solid #e9ecef;
  }

  .fee-item:last-child {
    border-bottom: none;
  }

  .fee-label {
    color: #4a4e69;
    font-weight: 500;
  }

  .fee-value {
    color: #2b2d42;
    font-weight: 600;
  }

  .alevel-features {
    margin-bottom: 1.5rem;
  }

  .features-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  .feature-item {
    display: flex;
    align-items: flex-start;
    gap: 0.8rem;
    color: #4a4e69;
    font-size: 0.95rem;
    line-height: 1.4;
  }

  .feature-icon {
    color: #4361ee;
    margin-top: 0.2rem;
    flex-shrink: 0;
  }

  .alevel-form {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  }

  .form-title {
    color: #2b2d42;
    font-size: 1.3rem;
    margin-bottom: 1rem;
    text-align: center;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
  }

  .form-input, .form-textarea {
    padding: 0.8rem 1rem;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    font-size: 0.95rem;
    transition: all 0.2s;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    font-family: inherit;
  }

  .form-input:focus, .form-textarea:focus {
    border-color: #4361ee;
    box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);
  }

  .form-textarea {
    min-height: 100px;
    resize: vertical;
  }

  .submit-button {
    padding: 0.9rem;
    border-radius: 8px;
    background: linear-gradient(90deg, #4361ee, #3a0ca3);
    color: #fff;
    font-weight: 600;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.5rem;
    box-shadow: 0 4px 6px rgba(67, 97, 238, 0.2);
  }

  .submit-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(67, 97, 238, 0.25);
  }

  .submit-button:active {
    transform: translateY(0);
  }

  .submit-button.success {
    background: #48BB78;
    box-shadow: 0 4px 6px rgba(72, 187, 120, 0.2);
  }

  .submit-button.loading {
    background: #4895ef;
    cursor: not-allowed;
  }

  .button-icon {
    margin-right: 8px;
  }

  @media (max-width: 768px) {
    .alevel-card {
      padding: 1.5rem;
    }
    
    .semesters-container, .features-grid {
      grid-template-columns: 1fr;
    }
    
    .alevel-highlights {
      flex-direction: column;
      align-items: center;
      gap: 0.8rem;
    }
  }
`;

// Add styles to the document head
const styleElement = document.createElement('style');
styleElement.innerHTML = styles;
document.head.appendChild(styleElement);